import axios from '@/utils/axios';
import type {
  ChatAccessGroup,
  ChatAccessGroupPayload,
  ChatOpenChannelPayload,
  ChatOpenChannelResponseData,
} from '../types';

type ApiResponse<T> = {
  data: T;
  message?: string;
};

export async function getChatAccessGroups(): Promise<ChatAccessGroup[]> {
  const {
    data: { data },
  } = await axios.get<ApiResponse<ChatAccessGroup[]>>('/chat/access-groups');

  return data;
}

export async function createChatAccessGroup(
  payload: ChatAccessGroupPayload
): Promise<ChatAccessGroup> {
  const {
    data: { data },
  } = await axios.post<ApiResponse<ChatAccessGroup>>(
    '/chat/access-groups',
    payload
  );

  return data;
}

export async function updateChatAccessGroup(
  id: number,
  payload: ChatAccessGroupPayload
): Promise<ChatAccessGroup> {
  const {
    data: { data },
  } = await axios.put<ApiResponse<ChatAccessGroup>>(
    `/chat/access-groups/${id}`,
    payload
  );

  return data;
}

export async function deleteChatAccessGroup(id: number): Promise<void> {
  await axios.delete(`/chat/access-groups/${id}`);
}

export async function openChatChannel(
  payload: ChatOpenChannelPayload
): Promise<ChatOpenChannelResponseData> {
  const {
    data: { data },
  } = await axios.post<ApiResponse<ChatOpenChannelResponseData>>(
    '/chat/channels/open',
    payload
  );

  return data;
}
